module.exports = __webpack_public_path__ + "media/images/flags/GN-2af5bb2f91a05ea7337c88b03bfc262f.svg";